import React, { useRef, useState, useEffect } from "react";
import LoginBannerhi from "../../assets/images/HindiBanner.png";
import LoginBannermr from "../../assets/images/MarathiBanner.png";
import LoginBannerka from "../../assets/images/KannadaBanner.png";
import LoginBannerte from "../../assets/images/TeluguBanner.png";
import LoginBannerpb from "../../assets/images/PunjabiBanner.png";
import LoginBannergu from "../../assets/images/GujaratiBanner.png";
import LoginBannerta from "../../assets/images/tamilBanner.png";
import LoginBannerbn from "../../assets/images/BengaliBanner.png";
import LoginBanneror from "../../assets/images/OriyaBanner.png";

import LeftArrow from "../../assets/images/left.png";
import RightArrow from "../../assets/images/rightArrow.png";
import Fire from "../../assets/images/source.gif";
import Header from "../../components/layout/Header";
import CustomModal from "../modal/index.js";
import { Button } from "react-bootstrap";
import { decryptJSON, fetchAPI } from "../service/Encrtyption.js";
import { useForm } from "react-hook-form";
import { json, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import {
  cropValue,
  login,
  spinStatus,
  setSecondaryMessageAction,
} from "./redux/store.js";
import { Loader } from "../loader/index.js";
import { useParams } from "react-router-dom";
import ReactGA from 'react-ga4';
import OTPInput from "react-otp-input";
import { useSelector } from "react-redux";
import { genuityCheckData } from "./redux/store.js";
import GenuityCheck from "../../assets/images/delegateBottle.svg";
import Right from "../../assets/images/right.png";
import SpinImageHi from "../../assets/images/spinImage_hi.png";
import SpinImageMr from "../../assets/images/spinImage_mr.png";
import SpinImageKa from "../../assets/images/spinImage_ka.png";
import SpinImageTe from "../../assets/images/spinImage_te.png";
import SpinImagePb from "../../assets/images/spinImage_pb.png";
import SpinImageGj from "../../assets/images/spinImage_gj.png";
import SpinImageTa from "../../assets/images/spinImage_ta.png";
import SpinImageBn from "../../assets/images/spinImage_bn.png";
import SpinImageOr from "../../assets/images/spinImage_or.png";

import CustomRoulette from "../WheelComponent/index.js";
import Close from "../../assets/images/close.png";
import ChilliImage from '../../assets/images/mirchi.png';
import OtherCropImage from '../../assets/images/Other_Crop.png';
import CottonImage from '../../assets/images/cotton-img.png';
import notGeniuneImg from "../../assets/images/notgenuine.png";
import SuccessIcon from "../../../src/assets/images/successIcon.png";
import DelegateBottle from "../../../src/assets/images/delegateBottle.svg";
import PrivacyConsentContent from "../content/PrivacyConsentContent.js";
import { getPrivacyConsentNotice } from "../content/index.js";
import { parseScanData } from "../../utils/parseScanData";
import { setOtpVerified } from "../../utils/otpSession";
import { convertMediaUrls } from "../../utils/authenticatedImages.js";


const Login = () => {
  const [selectedCrop, setSelectedCrop] = useState(false);
  const [modalShow, setModalShow] = useState(false);
  const [GenunityCheckModal, setGenunityCheckModal] = useState(false);
  const [errroMsg, setErrorMsg] = useState("");
  const [disableBtn, setDisableBtn] = useState(false);
  const [otpDigits, setOtpDigits] = useState(""); // State for OTP digits 
  const [loading, setLoading] = useState(false);
  const [oTPSec, setOTPSec] = useState(false);
  const [scanResponseData, setScanResponseData] = useState({});
  const [ErrorModalGenunity, setErrorModalGenunity] = useState(false);
  const [scanErrorResponseData, setscanErrorResponseData] = useState({});
  const [spinModalShow, setSpinModalShow] = useState(false);
  const [stopPrizeNumber, setStopPrizeNumber] = useState("");
  const [mobileNumber, setMobileNumber] = useState("");
  const [mobileNumberError, setMobileNumberError] = useState("");
  const [scanedDataObject, setScanedDataObject] = useState(false);
  const [rewardUpdateModal, setRewardUpdateModal] = useState(false);
  const [resend, setResend] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [surl, setsurl] = useState('');
  const [name, setName] = useState('');
  const { t, i18n } = useTranslation();
  const { lang } = useParams();
  const [showPrivacyModal, setShowPrivacyModal] = useState(false);
  const [privacyAccepted, setPrivacyAccepted] = useState(false);
  const [videoModal, setvideoModal] = useState(true);
  const currentLanguage = i18n.language;
  //console.log("currentLanguage+"+currentLanguage);
  const navigate = useNavigate();
  const dispatch = useDispatch();

  //login object to send for server
  const productName = sessionStorage.getItem('storedProductName');
  const [loginSubmit, setLoginSubmit] = useState({
    deviceType: "WEB",
    mobileNumber: "",
    otp: "",
    destinationURL: "/customer/saveGenuinityCheckDetails_V3_acviss",
    deviceId: "",
    otpVerified: false,
    countryId: 5,
    directScanConsentAgreed: true,
  });

  ///dat form the store
  const user = useSelector((state) => state?.user);
  const scanedData = useSelector((state) => state?.scandataUrl);
  const genunityData = useSelector((state) => state?.genunityData);
  const giftImageUrl = useSelector((state) => state?.giftImageUrl);
  const giftMessage = useSelector((state) => state?.message);
  const [timer, setTimer] = useState(35);
  const [showTimer, setShowTimer] = useState(false);
  const [otpValid, setOtpValid] = useState(false);
  // console.log("giftImageUrl"+giftImageUrl);

  const [wheelItems, setWheelTems] = useState([]);
  const isDelegateProduct =
    String(scanedDataObject?.product || productName || "")
      .trim()
      .toLowerCase() === "delegate";
  useEffect(() => {
    if (scanedData !== null && scanedData !== undefined && scanedData !== "") {
      const result = JSON.parse(scanedData);
      setScanedDataObject(result);
    }

  }, [scanedData]);

  useEffect(() => {
    if (!showTimer) return;

    const countdown = setInterval(() => {
      if (otpValid) {
        clearInterval(countdown);
        setShowTimer(false);
        setOtpDigits("");
        setResend(true);
        console.log('Timer stopped due to otpValid = true');
        return;
      }

      setTimer((prevTime) => {
        if (prevTime <= 1) {
          clearInterval(countdown);
          setShowTimer(false);
          setOtpDigits("");
          setResend(true);
          return 0;
        }
        return prevTime - 1;
      });
    }, 1000);

    return () => clearInterval(countdown);
  }, [otpValid, showTimer]);


  const formatTime = (seconds) => {
    const min = Math.floor(seconds / 60);
    const sec = seconds % 60;
    return `${min < 10 ? '0' + min : min}:${sec < 10 ? '0' + sec : sec}`;
  };


  const {
    register,
    handleSubmit,
    formState: { errors },
    clearErrors,
  } = useForm();


  const [formData, setFormData] = useState({
    mobileNumber: "",
    deviceId: "",
    userAcceptanceKey: "0",
    destinationURL: "/customer/sendOTPForMicrosite",
  });

  ///  enble for submit btn 

  //validations

  const handleCropChange = (event) => {
    const value = event.target.value;
    setSelectedCrop(value);
    setFormErrors((prevErrors) => ({
      ...prevErrors,
      cropName: false,
    }));
    dispatch(cropValue(value));
  };

  const handleInputNameChange = (e) => {
    const filteredValue = e.target.value
      .replace(/[^\p{L}\p{M}\s]/gu, "").slice(0, 50);

    setName(filteredValue);

    if (filteredValue.length >= 3) {
      setFormErrors((prev) => ({
        ...prev,
        name: false,
      }));
    }

    clearErrors("name");
  };

  // const handleInputNameChange = (e) => {
  //   // debugger;
  //   const { name, value } = e.target;
  //   let validValue = value;
  //   if (name === "name") {
  //     const inputValue = value;
  //     const namevalue = inputValue.replace(/[^a-zA-Z ]/g, "");
  //     const alphabeticValue = namevalue.slice(0, 50);
  //     e.target.value = alphabeticValue;
  //     if (alphabeticValue.length >= 3) {
  //       setFormErrors((prevErrors) => ({
  //         ...prevErrors,
  //         name: false,
  //       }));
  //     }
  //     setName(alphabeticValue);
  //   }
  //   clearErrors(name);
  // };


  const handleMobileInputChange = (e) => {
    // debugger;
    const { name, value } = e.target;
    let validValue = value;
    if (name === "mobileNumber") {
      const inputValue = value;
      const numericValue = inputValue.replace(/\D/g, ""); // Remove non-numeric characters
      const limitedValue = numericValue.slice(0, 10); // Limit input to 10 characters
      const validValue = /^[6-9]\d{0,9}$/.test(limitedValue) ? limitedValue : ""; // Ensure the first digit is 6, 7, 8, or 9 and limit to 10 digits
      e.target.value = validValue; // Update the input value  
      if (validValue.length >= 10) {
        setMobileNumber(validValue);
        setFormErrors((prevErrors) => ({
          ...prevErrors,
          mobileNumber: false,
        }));
        setFormData((prevFormData) => {
          const newFormData = {
            ...prevFormData,
            [name]: validValue,
          };
          return newFormData;
        });
      } else {
        setMobileNumber('');
        setOTPSec(false);
      }
    }

    clearErrors(name);
  };

  useEffect(() => {
    if ((!isDelegateProduct || selectedCrop) && name && mobileNumber) {
      setDisableBtn(true);
    } else {
      setDisableBtn(false);
    }
  }, [isDelegateProduct, selectedCrop, name, mobileNumber]);


  ////OTP submit and form submit for login

  const onSubmit = async (e) => {
    if (!privacyAccepted) {
      setShowPrivacyModal(true);
      return;
    }
    // Validate form fields
    let errors = {};
    if (!name || name.trim() === "") {
      errors = { ...errors, name: true };
    } else {
      errors = { ...errors, name: false };
    }

    if (!mobileNumber) {
      errors = { ...errors, mobileNumber: true };
    } else {
      errors = { ...errors, mobileNumber: false };
    }

    if (isDelegateProduct && !selectedCrop) {
      errors = { ...errors, cropName: true };
    } else {
      errors = { ...errors, cropName: false };
    }

    setFormErrors(errors);

    // Proceed with API call if there are no validation errors
    if (!errors.name && !errors.mobileNumber && !errors.cropName) {
      const scanedData = sessionStorage.getItem('k');

      if (scanedData) {
        ReactGA.event({
          category: 'User Login',
          label: resend ? "Resend OTP Button" : "Send OTP Button",
          action: resend ? 'Resend OTP Clicked' : 'Send OTP Clicked'
        });

        setLoading(true);

        try {
          // Replace with your actual API endpoint and formData
          const responseData = await fetchAPI(
            process.env.REACT_APP_API_URL,
            formData,
            {
              appLangCode: currentLanguage
            }
          );

          console.log("Submitted form data: " + JSON.stringify(formData));

          const jsonReposneData = JSON.parse(responseData);

          console.log("Response from API: " + JSON.stringify(jsonReposneData));

          if (jsonReposneData.statusCode === "200") {
            sessionStorage.setItem('mbn', jsonReposneData.mobileNumber);
            sessionStorage.setItem('cid', jsonReposneData.customerId);
            dispatch(login(jsonReposneData));
            setOtpDigits("");
            setOTPSec(true); // Set some state indicating OTP section is shown
            setTimer(30);
            setOtpValid(false);
            setShowTimer(true);
            setResend(false);
          } else if (jsonReposneData.statusCode === "103") {
            handleLoginModal(); // Handle login modal or redirection
          } else if (jsonReposneData.statusCode === "101") {
            // alert('regrister'); 
            const decryptedData = decryptJSON(scanedData).replace(/"/g, '');
            registerNewUser(decryptedData);
            sessionStorage.setItem('mbn', jsonReposneData.mobileNumber);
            sessionStorage.setItem('cid', jsonReposneData.customerId);
            setOTPSec(true); // Set some state indicating OTP section is shown
            setTimer(30);
            setOtpValid(false);
            setShowTimer(true);
            setResend(false);
            //navigate(`/${i18n.language}${currentPath}?${decodeURIComponent(decryptedData)}`);
          }
        } catch (error) {
          console.error("Error fetching API:", error);
          // Handle API error
        } finally {
          setLoading(false); // Set loading state to false after API call
        }
      } else {
        setErrorMsg(t('pleasescan'));
      }
    }
  };


  //resend verfiy otp for forcecheckout

  const handleLoginModal = async () => {
    // debugger;
    setLoading(true);
    try {
      // Update user acceptance key to '1' and update the formData state
      const updatedFormData = {
        ...formData,
        userAcceptanceKey: "1",
      };
      setFormData(updatedFormData);

      // Resubmit the form with updated data
      const updatedResponseData = await fetchAPI(
        process.env.REACT_APP_API_URL,
        updatedFormData
      );
      const updatedJsonResponseData = JSON.parse(updatedResponseData);
      if (updatedJsonResponseData.statusCode === "200") {
        setOtpVerified(false);
        dispatch(login(updatedJsonResponseData));
        const scanedData = sessionStorage.getItem('k');
        sessionStorage.setItem('mbn', updatedJsonResponseData.mobileNumber);
        sessionStorage.setItem('cid', updatedJsonResponseData.customerId);
        const surlderypted = decryptJSON(scanedData).replace(/"/g, '');
        setOTPSec(true);
        setTimer(30);
        setOtpValid(false);
        setShowTimer(true);
        setResend(false);
      } else {
        navigate(`/${i18n.language}/login`);
      }
    } catch (error) {
      console.error("Error fetching API:", error);
    } finally {
      setLoading(false); // Set loading state to false after API call is completed
    }
  };

  ///validations

  const handleOTPInputChange = (otpDigits) => {
    setLoginSubmit((prevFormData) => ({
      ...prevFormData,
      ...scanedDataObject,
      otp: otpDigits,
      mobileNumber: mobileNumber,
      customerId: user?.customerId,
      moduleType: productName
    }));

    setOtpDigits(otpDigits);
  };

  function OTPValidate(event) {
    const pattern = /[0-9]/; // Allow only digits (0-9)
    const inputChar = String.fromCharCode(event.charCode);
    if (!pattern.test(inputChar)) {
      event.preventDefault();
    }
  }

  const renderInput = (inputProps, index) => (
    <>
      <input
        {...inputProps}
        type="tel"
        inputMode="numeric"
        style={{ width: "25%", margin: "4px", height: "50px" }}
        pattern="[0-9]*"
        onKeyPress={OTPValidate}

      />
    </>
  );

  const handleOTPKeyDown = (e) => {
    // Allow only numeric key codes (0-9) and specific control keys (e.g., Backspace, Delete)
    const allowedKeyCodes = [8, 9, 46]; // Backspace (8), Tab (9), Delete (46)

    if (!allowedKeyCodes.includes(e.keyCode)) {
      // Prevent default for non-allowed key codes (e.g., letters, symbols)
      if (e.keyCode < 48 || e.keyCode > 57) {
        e.preventDefault();
      }
    }
  };
  //end otp code

  useEffect(() => {
    const queryString = window?.location?.href?.split("?")[1];
    const queryParams = {};
    queryString?.split("&")?.forEach((pair) => {
      const [key, value] = pair?.split("=");
      queryParams[key] = value;
    });
    const uParamValue = queryParams["u"];
    setsurl(uParamValue);
    // console.log(surl +"niha"); 
  }, []);

  ///login code for submititing the details
  const onLogin = async () => {
    // debugger;
    setLoading(true);
    ReactGA.event({
      category: 'User Verify OTP',
      label: 'OTP Submitted',
      action: 'Verify OTP Clicked'
    });

    try {
      const { otp } = loginSubmit; // Assuming 'otp' is the key for the OTP value
      const trimmedOtp = otp.trim();
      if (!otp || otp.trim() === "" || trimmedOtp.length !== 4) {
        // Check if OTP is empty or only whitespace
        setErrorMsg(t("otpError")); // Set an error message for empty OTP
        setLoading(false);
        return;
      }

      if (!surl) {
        // setErrorMsg("Please scan the QR code to proceed");
        setErrorMsg(t("sessionExperied"));
        setLoading(false);
        return;
      }

      const responseData = await fetchAPI(
        process.env.REACT_APP_API_URL_SCAN,
        loginSubmit,
        {
          mobileNumber: user?.mobileNumber,
          customerId: user?.customerId,
          userAuthorizationToken: "",
          deviceid: "WEB",
          appLangCode: currentLanguage,
        }
      );
      // debugger;
      console.log(JSON.stringify(loginSubmit) + "otp submit data");
      //  alert(JSON.stringify(loginSubmit));
      const jsonReposneData = JSON.parse(responseData);
      const mediaData = await convertMediaUrls(jsonReposneData);
      console.log(jsonReposneData, "otp response data");
      console.log(mediaData, "otp response mediaData data");
      if (
        jsonReposneData?.statusCode === "200" && jsonReposneData?.uq_responseCode === "100") {
        console.log("jsonReposneData" + JSON.stringify(jsonReposneData));
        // console.log(JSON.stringify(jsonReposneData.strongArmObject)+"strongArmObject"); 
        // const strongArmObject = jsonReposneData.strongArmObject;
        let resProductID = null;
        if (jsonReposneData.strongArmObject?.textTwo) {
          resProductID = jsonReposneData.strongArmObject.textTwo;
        }
        setScanResponseData(mediaData);
        dispatch(genuityCheckData(mediaData));
        dispatch(setSecondaryMessageAction(mediaData?.primaryRewardMsg || ""));
        setGenunityCheckModal(true);
        setOtpValid(true);
        setOtpVerified(true);
        setShowTimer(false);
      } else if (jsonReposneData?.statusCode === "200" && jsonReposneData?.uq_responseCode != "100") {
        //debugger;
        setLoading(false);
        setscanErrorResponseData(mediaData);
        setErrorModalGenunity(true);
        // setNavbarWhite(true);
      } else {
        if (jsonReposneData?.statusCode === "123" || jsonReposneData?.statusCode === "122") {
          setDisableBtn(true);
          // setErrorMsg(jsonReposneData?.message);
          setOtpDigits("");
          setOtpValid(true);
          setOtpVerified(false);
          setShowTimer(false);
          setResend(true);
        }
        else {
          setOtpValid(false);
          setOtpVerified(false);
          setErrorMsg(jsonReposneData?.message || t("invalid_OTP"));
        }

      }
    } catch (error) {
      //  debugger;
      setErrorMsg("Please scan the QR code to proceed");
      console.error("Error fetching API:", error);
    } finally {
      setLoading(false);
    }
  };

  // ///login code for submititing the details
  // const onLogin = async () => {
  //   // debugger;
  //   setLoading(true);
  //   ReactGA.event({
  //     category: 'User Verify OTP',
  //     action: 'CLK_VERIFY_OTP_BTN'
  //   });

  //   try {
  //     const { otp } = loginSubmit; // Assuming 'otp' is the key for the OTP value
  //     const trimmedOtp = otp.trim();
  //     if (!otp || otp.trim() === "" || trimmedOtp.length !== 6) {
  //       // Check if OTP is empty or only whitespace
  //       setErrorMsg(t("otpError")); // Set an error message for empty OTP
  //       setLoading(false);
  //       return;
  //     }

  //     if (!surl) {
  //       // setErrorMsg("Please scan the QR code to proceed");
  //       setErrorMsg(t("sessionExperied"));
  //       setLoading(false);
  //       return;
  //     }

  //     const responseData = await fetchAPI(
  //       process.env.REACT_APP_API_URL_SCAN,
  //       loginSubmit,
  //       {
  //         mobileNumber: user?.mobileNumber,
  //         customerId: user?.customerId,
  //         userAuthorizationToken: "",
  //         deviceid: "WEB",
  //         appLangCode: currentLanguage
  //       }
  //     );
  //     // debugger;
  //     console.log(JSON.stringify(loginSubmit) + "otp submit data");
  //     //  alert(JSON.stringify(loginSubmit));
  //     const jsonReposneData = JSON.parse(responseData);
  //     // console.log(jsonReposneData, "otp response data");
  //     if (
  //       jsonReposneData?.statusCode === "200" && jsonReposneData?.uq_responseCode === "100") {
  //       // debugger;
  //       console.log("jsonReposneData" + JSON.stringify(jsonReposneData));
  //       //  alert(JSON.stringify(jsonReposneData));
  //       setScanResponseData(jsonReposneData);
  //       dispatch(genuityCheckData(jsonReposneData));
  //       setGenunityCheckModal(true);
  //     } else if (jsonReposneData?.statusCode === "200" && jsonReposneData?.uq_responseCode != "100") {
  //       //debugger;
  //       setLoading(false);
  //       setscanErrorResponseData(jsonReposneData);
  //       setErrorModalGenunity(true);
  //     } else {
  //       if (jsonReposneData?.statusCode === "123" || jsonReposneData?.statusCode === "122") {
  //         setDisableBtn(true);
  //         // setErrorMsg(jsonReposneData?.message);
  //         setOtpDigits("");
  //         setShowTimer(false);
  //         setResend(true);
  //       }
  //     }
  //   } catch (error) {
  //     //  debugger;
  //     setErrorMsg(t('pleasescan'));
  //     console.error("Error fetching API:", error);
  //   } finally {
  //     setLoading(false);
  //   }
  // };

  //end login code

  const hide = () => {
    setErrorMsg(""); // Assuming you have a state to manage the error message
  };

  //change baneer based on the lang

  let bannerImageSrc;
  if (lang === 'hi') {
    bannerImageSrc = LoginBannerhi;
  } else if (lang === 'mr') {
    bannerImageSrc = LoginBannermr;
  } else if (lang === 'kn') {
    bannerImageSrc = LoginBannerka;
  } else if (lang === 'te') {
    bannerImageSrc = LoginBannerte;
  } else if (lang === 'pa') {
    bannerImageSrc = LoginBannerpb;
  } else if (lang === 'gu') {
    bannerImageSrc = LoginBannergu;
  } else if (lang === 'ta') {
    bannerImageSrc = LoginBannerta;
  } else if (lang === 'bn') {
    bannerImageSrc = LoginBannerbn;
  } else if (lang === 'or') {
    bannerImageSrc = LoginBanneror;
  }
  else {
    bannerImageSrc = LoginBannerhi;
  }

  //change logo based on the lang

  let bannerLogoSrc;
  if (lang === 'hi') {
    bannerLogoSrc = SpinImageHi;
  } else if (lang === 'mr') {
    bannerLogoSrc = SpinImageMr;
  } else if (lang === 'kn') {
    bannerLogoSrc = SpinImageKa;
  } else if (lang === 'te') {
    bannerLogoSrc = SpinImageTe;
  } else if (lang === 'pa') {
    bannerLogoSrc = SpinImagePb;
  } else if (lang === 'gu') {
    bannerLogoSrc = SpinImageGj;
  } else if (lang === 'ta') {
    bannerLogoSrc = SpinImageTa;
  } else if (lang === 'bn') {
    bannerLogoSrc = SpinImageBn;
  } else if (lang === 'or') {
    bannerLogoSrc = SpinImageOr;
  }
  else {
    bannerLogoSrc = SpinImageHi;
  }

  ///for pop up 
  const openSpinWheel = () => {
    ReactGA.event({
      category: 'User Open Spin Wheel',
      label: 'Spin Wheel Button',
      action: 'Spin Wheel Open Button Clicked'
    });
    // debugger;
    setGenunityCheckModal(false);
    setModalShow(false);
    setSpinModalShow(true);
  };



  const handleSpin = () => {
    dispatch(spinStatus(true));
  };

  // for close popups'
  const handleCloseModal = () => {
    setSpinModalShow(false);
    setRewardUpdateModal(true);
  };

  useEffect(() => {
    if (scanedData !== null && scanedData !== undefined && scanedData !== "") {
      const result = JSON.parse(scanedData);
      setScanedDataObject(result);
    }
  }, [scanedData]);


  const handleNavigation = () => {
    //debugger;
    if (user) {
      navigate(`/${lang}/home`);
    } else {
      const currentPath = `/login`;
      navigate(`/${lang}${currentPath}}`);
    }
  };

  const [formErrors, setFormErrors] = useState({
    name: false,
    mobileNumber: false,
    cropName: false
  });

  //register
  const registerNewUser = async () => {

    //debugger;
    const obj = {
      cepFlag: false,
      countryId: 5,
      customerType: "Farmer",
      deviceId: "",
      deviceToken: "",
      firstName: name,
      geolocation: "",
      languageId: "1",
      lastName: name,
      mobileNumber: mobileNumber,
      optInWhatsApp: false,
      pincode: scanedDataObject.pincode,
      referrer: "",
      rhrdFlag: false,
      villageLocation: "",
      wheatProgramFlag: false,
      destinationURL: "/customer/registerCustomerForMicrosite",
    }

    ReactGA.event({
      category: 'User Register',
      label: 'Register Button',
      action: 'Register Button Clicked'
    });

    try {
      const responseData = await fetchAPI(
        process.env.REACT_APP_API_URL,
        obj,
        {
          authKey: "",
          methodName: "",
          sharedWith: "",
        }
      );

      console.log("jsonReposneDataOBJ" + JSON.stringify(formData));
      setOtpVerified(false);
      const jsonReposneData = JSON.parse(responseData);
      console.log("jsonReposneData" + JSON.stringify(jsonReposneData));
      if (jsonReposneData.statusCode == 200 && jsonReposneData.otp) {
        dispatch(login(jsonReposneData));
        setOTPSec(true);
        sessionStorage.setItem('mbn', jsonReposneData.mobileNumber);
        sessionStorage.setItem('cid', jsonReposneData.customerId);
      } else {
        setErrorMessage(jsonReposneData.message);
        setOTPSec(false);
      }
    } catch (error) {
      console.error("Error fetching API:", error);
      setErrorMessage(error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <Header />
      <div className="main">
        <div className="container p-0">
          {loading && <Loader />}
          <div className="card border-0">
            <img
              src={bannerImageSrc}
              className="img-fluid w-100"
              alt="banner"
            />
            <div className="card-body pb-2 pt-0 pb-2">
              <div>
                <form onSubmit={handleSubmit(onSubmit)}>
                  {isDelegateProduct && (
                    <div className="form-group mt-3">
                      <div className="d-flex justify-content-between align-items-center" style={{ flexWrap: "wrap" }}>
                        <div className="form-check form-check-inline">
                          <input className="form-check-input" type="radio" name="cropName" id="Cotton" value="Cotton" onChange={handleCropChange} />
                          <img src={CottonImage} alt="Cotton" className="cropImg" style={{ width: "28px" }} />
                          <label className="form-check-label cropName" htmlFor="Cotton">
                            {t("cottn")}
                          </label>
                        </div>
                        <div className="form-check form-check-inline">
                          <input className="form-check-input" type="radio" name="cropName" id="Chilli" value="Chilli" onChange={handleCropChange} />
                          <img src={ChilliImage} alt="Chilli" className="cropImg" style={{ width: "28px" }} />
                          <label className="form-check-label cropName" htmlFor="Chilli">
                            {t("chilli")}
                          </label>
                        </div>
                        <div className="form-check form-check-inline">
                          <input className="form-check-input" type="radio" name="cropName" id="Other" value="Other" onChange={handleCropChange} />
                          <img src={OtherCropImage} alt="Other" className="cropImg" style={{ width: "28px" }} />
                          <label className="form-check-label cropName" htmlFor="Other">
                            {t("other")}
                          </label>
                        </div>
                      </div>
                      {formErrors.cropName && <div className="text-danger">{t("cropErrorMsg")}</div>}
                    </div>
                  )}

                  {/* <label htmlFor="name">{t("name")}</label> */}
                  <div className="form-group">
                    <input type="text" className={`form-control shadow  mb-1 ${errors.mobileNumber ? "is-invalid" : ""
                      }`}
                      placeholder={t("name")}
                      name="name"
                      id="name"
                      value={name}
                      autoComplete="off"
                      onChange={handleInputNameChange}
                    />
                    {formErrors.name && <div className="text-danger">{t("nameErrorMsg")}</div>}
                  </div>

                  {/* <label htmlFor="mobileNumber"> {t("loginLabel")}</label> */}
                  <div className="form-group">
                    <input
                      type="tel"
                      className={`form-control shadow  mb-1 ${errors.mobileNumber ? "is-invalid" : ""
                        }`}
                      placeholder={t("loginPlaceHolder")}
                      name="mobileNumber"
                      id="mobileNumber"
                      maxLength="10"
                      autoComplete="off"
                      onChange={handleMobileInputChange} />
                    {formErrors.mobileNumber && <div className="text-danger">{t("mobileErrorMsg")}</div>}
                  </div>

                  {oTPSec && (
                    <div className="form-group mt-3" id="opt_input">
                      <div
                        className="mb-3"
                        style={{
                          display: 'flex',
                          justifyContent: 'space-between',
                          alignItems: 'center',
                        }}
                      >
                        <label htmlFor="number" className="mt-0" style={{ fontWeight: '600' }}>
                          {t("enterOTP")}
                        </label>

                        {showTimer && (<div
                          id="timer"
                          style={{
                            color: 'white',
                            fontWeight: 600,
                            fontSize: '12px',
                            backgroundColor: 'red',
                            padding: '5px 15px',
                            borderRadius: '25px',
                            width: 'fit-content',
                            height: 'fit-content',
                          }}>
                          {formatTime(timer)}
                        </div>
                        )}
                      </div>

                      <OTPInput
                        onChange={handleOTPInputChange}
                        value={otpDigits}
                        inputStyle="otp__digit shadow"
                        numInputs={4}
                        separator={<span></span>}
                        renderInput={renderInput}
                        inputComponent={(props, index) => (
                          <input
                            {...props}
                            type="number" // Use type="tel" to display numeric keyboard on mobile devices
                            maxLength={1} // Allow only one character per input box
                            onKeyDown={handleOTPKeyDown}
                            onKeyPress={(e) => {
                              // Prevent default behavior for non-numeric key presses
                              if (e.which < 48 || e.which > 57) {
                                e.preventDefault();
                              }
                            }}
                          />
                        )}
                      />
                    </div>
                  )}

                  <div className="mt-3 px-3" id="privacyPolicyview">

                    <p className="privacyPolicyviewText ml-1">
                      <input
                        className="form-check-input"
                        type="checkbox"
                        id="privacyCheckbox"
                        checked={privacyAccepted}
                        onChange={() => {
                          if (!privacyAccepted) {
                            setShowPrivacyModal(true);
                          } else {
                            setPrivacyAccepted(false);
                          }
                        }}
                      />
                      {(() => {
                        const content = {
                          en: {
                            textBefore: [
                              "By clicking the submit button, You acknowledge reading",
                              "and accepting our"
                            ],
                            termsText: "Terms & Conditions",
                            andText: " and ",
                            privacyText: "Privacy Policy",
                            textAfter: ""
                          },
                          bn: {
                            textBefore: [
                              "সাবমিট বোতামে ক্লিক করে, আপনি স্বীকার করছেন যে আপনি পড়েছেন এবং গ্রহণ করছেন আমাদের"
                            ],
                            termsText: "শর্তাবলী",
                            andText: " এবং ",
                            privacyText: "গোপনীয়তা নীতি",
                            textAfter: ""
                          },
                          or: {
                            textBefore: [
                              "ସବମିଟ୍ ବଟନ୍‌ରେ କ୍ଲିକ୍ କରି, ଆପଣ ସ୍ୱୀକାର କରୁଛନ୍ତି ଯେ ଆପଣ ପଢ଼ିଛନ୍ତି ଏବଂ ଗ୍ରହଣ କରୁଛନ୍ତି ଆମର"
                            ],
                            termsText: "ନିୟମ ଏବଂ ସର୍ତ୍ତାବଳୀ",
                            andText: " ଏବଂ ",
                            privacyText: "ଗୋପନୀୟତା ନୀତି",
                            textAfter: ""
                          },
                          te: {
                            textBefore: [
                              "'సబ్మిట్' బటన్‌ను క్లిక్ చేయడం ద్వారా, మీరు",
                              " "
                            ],
                            termsText: "మా నిబంధనలు & షరతులు",
                            andText: " మరియు ",
                            privacyText: "గోప్యతా విధానాన్ని",
                            textAfter: " చదివి అంగీకరించారని నిర్ధారిస్తారు."
                          },
                          hi: {
                            textBefore:
                              "‘आगे बढ़ें’ बटन पर क्लिक करके, आप हमारी",
                            termsText: " नियम और शर्तें",
                            andText: [" तथा ", " "],
                            privacyText: "गोपनीयता नीति",
                            textAfter: " पढ़ने और स्वीकार करने की पुष्टि करते हैं।"
                          },
                          mr: {
                            textBefore: "सबमिट बटण क्लिक करून, आपण",
                            termsText: "आमच्या अटी व शर्ती",
                            andText: ["आणि", " "],
                            privacyText: "गोपनीयता धोरण",
                            textAfter: "वाचले असून त्यांना स्वीकारत असल्याची खात्री देता."
                          },
                          kn: {
                            textBefore: [
                              "'ಸಲ್ಲಿಸು' ಬಟನ್ ಕ್ಲಿಕ್ ಮಾಡುವ ಮೂಲಕ, ನೀವು",
                              " "
                            ],
                            termsText: "ನಮ್ಮ ನಿಯಮಗಳು ಮತ್ತು ಷರತ್ತುಗಳು",
                            andText: " ಮತ್ತು ",
                            privacyText: "ಗೌಪ್ಯತಾ ನೀತಿ",
                            textAfter: " ಓದಿ ಒಪ್ಪಿದ್ದೀರಿ ಎಂದು ದೃಢಪಡಿಸುತ್ತೀರಿ."
                          },
                          pa: {
                            textBefore: [
                              "'ਸਬਮਿਟ' ਬਟਨ 'ਤੇ ਕਲਿੱਕ ਕਰਕੇ, ਤੁਸੀਂ",
                              " "
                            ],
                            termsText: "ਸਾਡੇ ਨਿਯਮ ਅਤੇ ਸ਼ਰਤਾਂ",
                            andText: " ਅਤੇ ",
                            privacyText: "ਗੋਪਨੀਯਤਾ ਨੀਤੀ",
                            textAfter: " ਪੜ੍ਹਣ ਅਤੇ ਸਵੀਕਾਰ ਕਰਨ ਦੀ ਪੁਸ਼ਟੀ ਕਰਦੇ ਹੋ।"
                          },
                          gu: {
                            textBefore: [
                              "'સબમિટ' બટન ક્લિક કરીને, તમે",
                              " "
                            ],
                            termsText: "અમારી શરતો અને નિયમો",
                            andText: " અને ",
                            privacyText: "ગોપનીયતા નીતિ",
                            textAfter: " વાંચી અને સ્વીકારી હોવાનો સ્વીકાર કરો છો."
                          },
                          ta: {
                            textBefore:
                              "'சமர்ப்பிக்க' பொத்தானை அழுத்துவதன் மூலம், நீங்கள்",
                            termsText: " எங்கள் விதிமுறைகள் மற்றும் நிபந்தனைகள்",
                            andText: " மற்றும் ",
                            privacyText: "தனியுரிமைக் கொள்கை",
                            textAfter: " படித்து ஒப்புக்கொண்டீர்கள் என்பதை உறுதிப்படுத்துகிறீர்கள்."
                          }
                        };

                        const {
                          textBefore,
                          termsText,
                          andText,
                          privacyText,
                          textAfter
                        } = content[lang] || content.en;

                        return (
                          <>
                            {Array.isArray(textBefore) ? (
                              <>
                                {textBefore[0]}<br />
                                {textBefore[1]}{" "}
                              </>
                            ) : (
                              textBefore
                            )}
                            <a
                              style={{ color: '#DB710E' }}
                              target="_blank"
                              href={`${process.env.REACT_APP_API_URL_TC}${t("language")}`}
                              rel="noopener noreferrer"
                            >
                              <span className="text-decoration-underline">{termsText}</span>
                            </a>
                            {andText}
                            <a
                              style={{ color: '#DB710E' }}
                              target="_blank"
                              href="https://www.corteva.com/privacy.html"
                              rel="noopener noreferrer"
                            >
                              <span className="text-decoration-underline">{privacyText}</span>
                            </a>
                            {textAfter}
                          </>
                        );
                      })()}
                    </p>

                  </div>

                  {!oTPSec && (<button
                    type="submit"
                    className={`btn submitBtn text-center btn-primary w-100 py-2 center-textbtn mt-3 text-white text-uppercase
                      `}
                    //  ${!disableBtn ? "disabled" : ""} 
                    id="submitBtn"
                  // disabled={!disableBtn || loading}  

                  >
                    {t("submitBtn")}
                  </button>
                  )}

                  {resend && (
                    <div className="text-center mb-2 resend d-flex align-items-center justify-content-center">
                      {/* <div id="resend_text" className="text-center">{t('invalid_OTP')}? </div> */}
                      <div id="resend_text" className="text-center" style={{ fontSize: "14px" }}>{t('invalidOTP')}? </div>
                      <button
                        type="submit"
                        className={`btn text-center text-secondaryColor p-0 resendBtn `}>
                        {/* <b className="ml-1">{t('resend_OTP')}</b> */}
                        <b className="ml-1">{t('resendOTP')}</b>
                      </button>
                    </div>
                  )}
                </form>

                {oTPSec && (<button onClick={onLogin}
                  className={`btn  submitBtn text-center btn-primary w-100 py-2 center-textbtn mt-3 text-white text-uppercase
                    `}
                  id="submitBtn"
                // disabled={!disableBtn || loading}
                >
                  {t("login")}
                </button>
                )}

                {/* <p class="mt-4 px-3 profileText" style={{ fontSize: ' 13px' }}>
                  {t('profileText')}</p> */}

                {/* 
                {oTPSec && ( */}

                {/* )} */}

                {errroMsg && (
                  <>
                    <div
                      className="alert alert-warning alert-dismissible fade show mt-2"
                      role="alert"
                    >
                      {errroMsg}
                      <button
                        type="button"
                        className="close"
                        onClick={hide}
                      >
                        <span aria-hidden="true">&times;</span>
                      </button>
                    </div>
                  </>
                )}

                {/* Terms and condition modal */}
                <CustomModal
                  id={"privacyCheckbox"}
                  title={getPrivacyConsentNotice(lang).title}
                  content={
                    <div className="text-start " style={{
                      width: "100%", maxHeight: "60vh",
                      overflowY: "auto", overflowX: "hidden",
                      textAlign: "left", whiteSpace: "normal",
                      wordBreak: "break-word", overflowWrap: "break-word"
                    }}>
                      <PrivacyConsentContent lang={lang} modal />
                    </div>}
                  footer={
                    <div
                      className="w-100 d-flex justify-content-center align-items-center gap-3"
                    >

                      <Button onClick={() => {
                        setPrivacyAccepted(false);
                        setShowPrivacyModal(false);
                      }} className='mr-2 w-50'> {t('decline')} </Button>

                      <Button onClick={() => {
                        setPrivacyAccepted(true);
                        setShowPrivacyModal(false);
                      }} className='w-50'>{t('accept')}</Button>

                    </div>
                  }
                  show={showPrivacyModal}
                  onHide={() => setShowPrivacyModal(false)}
                />

                {/* //genuinityCheckModal */}
                <CustomModal
                  id={"genuinityCheckModal"}
                  title={
                    <>
                      {!scanedDataObject.hasOwnProperty('isSpinDone') && (
                        <button
                          type="button"
                          className="close"
                          aria-label="Close"
                          onClick={handleNavigation}
                        >
                          <img src={Close} alt="Close" />
                        </button>
                      )}

                      {t("genuityCheck")}
                    </>
                  }
                  content={
                    <>
                      {/* {scanResponseData?.productName} */}
                      <p className="mb-1 modalInfo">
                        {t("productName")}: {scanResponseData?.productName}
                      </p>
                      {scanResponseData?.productImageUrl && (
                        <img src={scanResponseData?.productImageUrl} alt="GenuityCheck" style={{ width: '100px', marginBottom: '1rem' }} />
                      )}
                      <div>
                        <img src={Right} alt="Right" />
                      </div>

                      <p className="mb-0 modalInfo fw-semibold text-secondaryColor" dangerouslySetInnerHTML={{ __html: scanResponseData?.uq_message }}></p>

                      {scanResponseData?.isSpinDone &&
                        scanResponseData?.showLuckyWinnerPopup === true && (
                        <p className="mb-0 modalInfo text-danger pt-2" dangerouslySetInnerHTML={{ __html: scanResponseData?.primaryRewardMsg }}>
                        </p>
                      )}
                    </>
                  }
                  footer={
                    <>
                      {scanResponseData?.showLuckyWinnerPopup !== true ? (
                        <Button
                          className="w-100 rounded-4 py-2"
                          onClick={() => {
                            setGenunityCheckModal(false);
                            navigate(`/${lang}/Reward`);
                          }}
                        >
                          {t("proceedToContinue")}
                        </Button>
                      ) : scanResponseData &&
                        scanResponseData.hasOwnProperty("isSpinDone") &&
                        !scanResponseData.isSpinDone && (
                          <>
                            <Button
                              className="w-100 rounded-4 py-2" onClick={openSpinWheel}>
                              {t("spinToWin")}
                            </Button>
                            {/* <p className="nextStep">{t('nextStep')}</p> */}
                          </>
                        )}

                    </>
                  }
                  show={GenunityCheckModal}
                  onHide={() => setGenunityCheckModal(false)}
                />

                {/*///not genuine case */}

                <CustomModal
                  id={"genuinityCheckModalError"}
                  title={
                    <>
                      <button
                        type="button"
                        className="close"
                        aria-label="Close"
                        onClick={() => {
                          setErrorModalGenunity(false);
                          handleNavigation();
                        }}
                      >
                        <img src={Close} alt="Close" />
                      </button>

                      {t("genuityCheck")}

                    </>
                  }

                  content={
                    <>

                      {/* <p className="mb-1 modalInfo">{t("serialNO")}: {scanResponseData.prodSerialNumber}</p> */}
                      {scanErrorResponseData?.productName && (
                        <p className="mb-1 modalInfo">
                          {t("productName")}:  {t("delegate")}
                        </p>
                      )}

                      <img src={GenuityCheck} alt="GenuityCheck" />
                      <div>
                        <img
                          src={notGeniuneImg}
                          alt="Right"
                          style={{ width: "50px" }}
                        />
                      </div>

                      <p className="mb-0 modalInfo" dangerouslySetInnerHTML={{ __html: scanErrorResponseData?.uq_message }}>
                      </p>

                      {scanErrorResponseData.isSpinDone && (
                        <p className="mb-0 modalInfo text-danger pt-2" dangerouslySetInnerHTML={{ __html: scanErrorResponseData?.primaryRewardMsg }}>
                        </p>
                      )}
                    </>
                  }
                  footer={<></>}
                  show={ErrorModalGenunity}
                  onHide={() => setErrorModalGenunity(false)}
                />

                {/* //////////////////////////////////////////////////////////////////////////////////////////// */}
                {/* SPIN MODALS */}



                {/* spin modal */}
                <CustomModal
                  id={"spinModal"}
                  title={""}
                  content={
                    <>
                      <div>
                        <img src={bannerLogoSrc} alt="Right" className="spinImgae spinwheelImg" />
                        <CustomRoulette
                          wheelItems={scanResponseData.wheelItems}
                          stopPrizeNumber={stopPrizeNumber}
                          closeModal={handleCloseModal}
                        />
                        <img src={LeftArrow} alt="" style={{ position: 'absolute', zIndex: '10', bottom: "-20px", left: '-7px' }} />
                        <img src={RightArrow} alt="" style={{ position: 'absolute', zIndex: '10', bottom: "-20px", right: '-7px' }} />

                      </div>
                    </>
                  }
                  footer={
                    <>
                      <Button onClick={handleSpin} className="m-auto rounded-4 py-2" style={{ width: '93%' }}>
                        {t("SpinWheel")}
                      </Button>
                    </>
                  }
                  show={spinModalShow}
                  onHide={() => setSpinModalShow(false)}
                />


                {/* ///reawrd update modal */}
                <CustomModal
                  id={"rewardUpdateModal"}
                  title={<>
                    <button
                      type="button"
                      className="close"
                      aria-label="Close"
                      onClick={handleNavigation}
                    >
                      <img src={Close} alt="Close" />
                    </button>

                  </>}
                  content={
                    <>
                      <img src={SuccessIcon} alt="SuccessIcon" className="succesIcon" />
                      <img src={giftImageUrl} alt="gifImage" className="giftedImg" />
                      <p className="congratulationsText mb-1 mt-1"> {t("giftcongratulations")} !!!</p>
                      <p className="rewardText mb-0" dangerouslySetInnerHTML={{ __html: giftMessage }}></p>
                      {/* <img src={Fire} alt="fire" /> */}
                    </>
                  }
                  show={rewardUpdateModal}
                  onHide={() => {
                    setRewardUpdateModal(false); // Close the modal
                    handleNavigation();
                  }}
                />

                {/* //stpes image */}
                <CustomModal
                  id={"videoModal"}
                  title=""
                  content={
                    <>
                      <iframe
                        width="100%"
                        height="410"
                        src="https://www.youtube.com/embed/gL9vUtWjMvQ?autoplay=1&loop=1"
                        frameBorder="0"
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowFullScreen
                        style={{ borderRadius: '10px' }}>
                      </iframe>
                    </>
                  }
                  footer={
                    <>
                      <Button className="px-4 rounded-4 py-2" onClick={() => setvideoModal(false)}>
                        {t("Skip")}
                      </Button>
                    </>
                  }
                  show={videoModal}
                  onHide={() => setvideoModal(false)}
                />

              </div>
            </div>
          </div>
        </div>
        {errorMessage && (
          <div
            className="alert alert-warning alert-dismissible fade show mt-2"
            role="alert"
          >
            {errorMessage}
            <button
              type="button"
              className="close"
              onClick={hide}
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
        )}
      </div>
    </>
  );
};

export default Login;
